"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ApplyForm = /** @class */ (function () {
    function ApplyForm() {
        this.fileMotivationInput = null;
        this.fileCVInput = null;
        this.initUploadFields();
    }
    ApplyForm.prototype.initUploadFields = function () {
        this.fileMotivationInput = document.querySelector('#file-motivation');
        this.fileCVInput = document.querySelector('#file-cv');
        this.addChangeListeners();
    };
    ApplyForm.prototype.addChangeListeners = function () {
        if (this.fileMotivationInput) {
            this.handleChangeFor(this.fileMotivationInput, 'motivation');
        }
        if (this.fileCVInput) {
            this.handleChangeFor(this.fileCVInput, 'cv');
        }
    };
    ApplyForm.prototype.handleChangeFor = function (el, classLabel) {
        if (classLabel === void 0) { classLabel = ''; }
        el.addEventListener('change', function (e) {
            // @ts-ignore
            var file = e.target.files;
            if (file) {
                var fileLabel = document.querySelector('.file-label--' + classLabel);
                if (fileLabel) {
                    fileLabel.classList.add('file-label--added');
                    fileLabel.innerHTML = "<img src=\"/assets/img/check.svg\" alt=\"\">" + file[0].name;
                }
            }
        });
    };
    return ApplyForm;
}());
exports.default = ApplyForm;
